import { render } from "./ImageDisplay.vue?vue&type=template&id=6dca1d68&scoped=true"
import script from "./ImageDisplay.vue?vue&type=script&lang=js"
export * from "./ImageDisplay.vue?vue&type=script&lang=js"

import "./ImageDisplay.vue?vue&type=style&index=0&id=6dca1d68&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dca1d68"]])

export default __exports__